function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useParams } from 'react-router-dom';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import useNavigate from '../../hooks/useNavigate';
import { loadCriteriaWizardSession } from '../../actions';
import RubriqAbstractToolbar from './RubriqAbstractToolbar';
var RubriqSetupWizard = function RubriqSetupWizard() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useParams = useParams(),
    sessionIdentity = _useParams.sessionIdentity,
    step = _useParams.step;
  var dispatch = useDispatch();
  var navigate = useNavigate();

  // load session
  useEffect(function () {
    dispatch(loadCriteriaWizardSession(sessionIdentity)).then(function (result) {
      setLoading(false);
      var steps = result.steps,
        currentStep = result.currentStep,
        responses = result.responses;
      var isValidStep = step === 'confirmation' || step === 'text-limit' || step && steps[step];
      var canRenderStep = isValidStep && (step === currentStep || responses[step]);
      if (!canRenderStep) {
        // requested step cannot be rendered so just redirect to whatever is the current step in the session
        navigate("/rubriq/abstract-writer/".concat(sessionIdentity, "/criteria/").concat(currentStep));
      }
    });
  }, []);
  if (loading) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RubriqAbstractToolbar, null), /*#__PURE__*/React.createElement(Outlet, null));
};
export default RubriqSetupWizard;